import React, { useEffect, useRef, useState } from "react";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import InjAsmntTabs from "./OverallAssmnt/AsmntTabs";
import ViewAsmntTabs from "./OverallAssmnt/ViewAsmntTabs";

const OverallAssessment = () => {

    const [centerId, setCenterId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [stepId, setStepId] = useState("");
    const [injuryAssessmentId, setInjuryAssessmentId] = useState("");
    const [dateOfAssessment, setDateOfAssessment] = useState("");
    const [palpation, setPalpation] = useState("");
    const [rangeOfMotion, setRangeOfMotion] = useState("");
    const [strengthTesting, setStrengthTesting] = useState("");
    const [specialTests, setSpecialTests] = useState("");
    const [functionalTest, setFunctionalTest] = useState("");
    const [fundamentalMovements, setFundamentalMovements] = useState("");
    const [performanceTest, setPerformanceTest] = useState("");
    const [status, setStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [injuryAssessmentList, setInjuryAssessmentList] = useState<any[]>([]);
    const [detailsList, setDetailsList] = useState<any>({});
    const [rsmDta, setRsmDta] = useState<any>(null);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [viewOpenModal, setViewOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchInjuryAssessment();
    }, [])

        async function fetchInjuryAssessment() {
            setIsLoading(true);
            const injuryResponse = await func.listOverallAssessment(null);
            setInjuryAssessmentList(Array.isArray(injuryResponse) ? injuryResponse : []);
            setShowTable(true)
            setIsLoading(false);
        }

    const filteredData = injuryAssessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateofAssessment)}</span>
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athlete_name}</span>
    };

    const asmntDateRender = (rowData) => {
        return <span>{formatDate(rowData.assessment_date)}</span>
    };

    const palpationrightRender = (rowData) => {
        return <span>{rowData.palpation_right}</span>
    };

    const palpationleftRender = (rowData) => {
        return <span>{rowData.palpation_left}</span>
    };

    const injuryAssessmentStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ?
            (<Link to="#" onClick={() => resumeAssessment(rowData)}>
                <i className="fas fa-arrow-left"></i>Resume
            </Link>)
            : ""}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editInjuryAssessment(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const viewDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => viewInjuryAssessment(rowData)}>
                <i className="feather-eye"></i>View
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.assessment_id;
        return (
            <Link to="#" onClick={() => deleteInjuryAssessment(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function resumeAssessment(rowData) {
        console.log("Resuming assessment for ID:", rowData.assessment_id);
        setInjuryAssessmentId(rowData.assessment_id)
        setAthleteId(rowData.athleteId)
        setStepId(rowData.steps_tracking)
        const resumeResponse = await func.resumeAssessment(rowData.assessment_id);
        setRsmDta(resumeResponse);
        setOpenModal(true)
    }

    async function newInjuryAssessment() {
        setIsEdit(false)
        setOpenModal(true)
        setCenterId("")
        setAthleteId("")
        setDateOfAssessment("")
        setFunctionalTest("")
        setFundamentalMovements("")
        setPalpation("")
        setInjuryAssessmentId("")
        setPerformanceTest("")
        setRangeOfMotion("")
        setStrengthTesting("");
        setSpecialTests("")
        setRsmDta(null);
    }

    async function editInjuryAssessment(rowData) {
        setInjuryAssessmentId(rowData.injuryAssessmentId)
        setAthleteId(rowData.athleteId)
        setDateOfAssessment(rowData.dateofAssessment)
        setFunctionalTest(rowData.functionalTest)
        setFundamentalMovements(rowData.fundamentalMovements)
        setPalpation(rowData.palpation)
        setPerformanceTest(rowData.performanceTest)
        setRangeOfMotion(rowData.rangeofMotion)
        setStrengthTesting(rowData.strengthTesting);
        setSpecialTests(rowData.specialTests)
        setStatus(rowData.status)
        setIsEdit(true)
        setOpenModal(true)
    }

    function deleteInjuryAssessment(injuryId: string) {
        const delteInjury = api.InjuryAssessment + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchInjuryAssessment();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    async function viewInjuryAssessment(rowData) {
        const assessId = rowData.assessment_id;
        const resumeResponse = await func.viewAssessmentDetails(assessId);
        setDetailsList(resumeResponse);
        setViewOpenModal(true)        
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjuryAssessment();
            } else {
                const formData = new FormData();
                // formData.append("centerId", centerId);
                formData.append("athleteId", athltId);
                formData.append("injuryId", injId);
                formData.append("dateOfAssessment", dateOfAssessment);
                formData.append("palpation", palpation);
                formData.append("rangeOfMotion", rangeOfMotion);
                formData.append("strengthTesting", strengthTesting);
                formData.append("specialTests", specialTests);
                formData.append("functionalTest", functionalTest);
                formData.append("fundamentalMovements", fundamentalMovements);
                formData.append("performanceTest", performanceTest);

                const createInjAssess = api.InjuryAssessment;
                fetch(createInjAssess, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                            fetchInjuryAssessment();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateInjuryAssessment() {
        const formData = new FormData();
        // formData.append("centerId", centerId);
        formData.append("athleteId", athleteId);
        formData.append("injuryId", injuryId);
        formData.append("dateOfAssessment", dateOfAssessment);
        formData.append("palpation", palpation);
        formData.append("rangeOfMotion", rangeOfMotion);
        formData.append("strengthTesting", strengthTesting);
        formData.append("specialTests", specialTests);
        formData.append("functionalTest", functionalTest);
        formData.append("fundamentalMovements", fundamentalMovements);
        formData.append("performanceTest", performanceTest);
        formData.append("status", status);

        const updateInjAssessmnt = api.InjuryAssessment + "/" + injuryAssessmentId;
        fetch(updateInjAssessmnt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchInjuryAssessment();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Overall Assessment</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjuryAssessment() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Assessment">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete Name"
                                                    body={athleteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="assessment_date"
                                                    header="Date of Assessment"
                                                    body={asmntDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {/* <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="palpation_right"
                                                    header="Right Palpation"
                                                    body={palpationrightRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="palpation_left"
                                                    header="Left Palpation"
                                                    body={palpationleftRender}
                                                    className="table-inset-btn"
                                                ></Column> */}
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryAssessmentStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("view") ?
                                                    <Column
                                                        className="text-link"
                                                        body={viewDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="lg">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">Injury Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <InjAsmntTabs resumeDta={rsmDta || null}/>
                </ModalBody>
            </Modal>

            <Modal
                show={viewOpenModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">View Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setViewOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <ViewAsmntTabs dta={detailsList || null}/>
                </ModalBody>
            </Modal>
        </>
    );
}

export default OverallAssessment;